import { errorMessages } from './constants';
export const errorHandler = new Map([
  ['already requested leave', errorMessages.ErrorMessageCreatingLeavesAlready]
]);
interface Error {
  message: string;
}
export function getDisplayMessage(errors: Error[]): string {
  const selectedError = errors.find((err: { message: string }) => {
    return errorHandler.has(err.message);
  });
  let displayMsg;
  if (selectedError !== undefined) {
    if (errorHandler.has(selectedError.message)) {
      displayMsg = errorHandler.get(selectedError.message);
    } else {
      displayMsg = errorMessages.ErrorMessageCommon;
    }
  } else {
    displayMsg = errorMessages.ErrorMessageCommon;
  }
  if (displayMsg === undefined) {
    return errorMessages.ErrorMessageCommon;
  } else {
    return displayMsg;
  }
}
